import React, { useMemo } from 'react';
import { useFlowConfigs } from '@src/hooks/flow/useFlowConfigs';
import FlowBar from './components/FlowBar/FlowBar';

const FlowPanel = ({ flowId }) => {
  const flowConfigs = useFlowConfigs();
  const currentFlow = useMemo(() => flowConfigs[flowId] || {}, [flowConfigs, flowId]);

  if (currentFlow.id) {
    return <FlowBar flowId={flowId} flowMeta={currentFlow} />;
  }
  return null;
};

export default FlowPanel;
